import React from 'react';
import ReactDataTable from '../../../../../../../components/_shared/Table/ReactDataTable';
import ReportFooter from '../../ReportsFooter/ReportFooter';
import { columns, mobileColumns } from './WmrcAvgResponseCloumn';
import ReactExpandableTable from '../../../../../../../components/_shared/Table/ReactExpandableTable';
import useWindowSize from '../../../../../../../../utils/hooks/useWindowSize';

const WmrcAvgResponseTable = ({
  isLoading,
  data,
  totaldata,
  tableOptions,
  handlePageClick,
  handleRowsPerPage,
  handleColumnSort,
  downloadPDF,
  downloadExcel,
  pageCount,
  reportData,
  reportCode,
  reportTableData,
  generatePDFFunction,
}) => {

  const size = useWindowSize();

  if (size.width < 768) {

    return (
      <>
      <h1 className="mb-2">WMRC Average Response Time</h1>
      <h6 className="text-muted mb-4 fw-normal">
        The table below shows average response times for WMRC users between {reportData?.startDate} and {reportData?.endDate}.
      </h6>

      <ReactExpandableTable
        isLoading={isLoading}
        data={data}
        mobileColumns={mobileColumns}
        pageCount={pageCount}
        activePage={tableOptions?.activePage}
        rowPerPages={tableOptions?.rowPerPages}
         totaldata={totaldata}
        handleRowsPerPage={handleRowsPerPage}
        removePagination={true}
        handleColumnSort={handleColumnSort}
        handlePageClick={handlePageClick}
      />

      <ReportFooter
        BackText="Back"
        PdfText="PDF"
        MailText="Mail"
        ExcelText="Excel"
        onPdfClick={downloadPDF}
        onExcelClick={downloadExcel}
        reportData={reportData}
        reportCode={reportCode}
        reportTableData={reportTableData}
        generatePDFFunction={generatePDFFunction}
      />
       </>
    );
  }

  return (
    <>
      <h1 className="mb-2">WMRC Average Response Time</h1>
      <h6 className="text-muted mb-4 fw-normal">
        The table below shows average response times for WMRC users between {reportData?.startDate} and {reportData?.endDate}.
      </h6>

      <ReactDataTable
        isLoading={isLoading}
        data={data}
        columns={columns}
        pageCount={pageCount}
        activePage={tableOptions?.activePage}
        rowPerPages={tableOptions?.rowPerPages}
         totaldata={totaldata}
        handleRowsPerPage={handleRowsPerPage}
        removePagination={false}
        handleColumnSort={handleColumnSort}
        handlePageClick={handlePageClick}
      />

      <ReportFooter
        BackText="Back"
        PdfText="PDF"
        MailText="Mail"
        ExcelText="Excel"
        onPdfClick={downloadPDF}
        onExcelClick={downloadExcel}
        reportData={reportData}
        reportCode={reportCode}
        reportTableData={reportTableData}
        generatePDFFunction={generatePDFFunction}
      />
    </>
  );
};

export default WmrcAvgResponseTable;
